import Vue from 'vue'
import { CreateElement } from 'src/vue'
import { Component, Prop } from 'vue-property-decorator'
import ClickOutside from 'vue-click-outside'

import { MemberPermissions } from '@src/data/member'
import { Subtitle1 } from '@src/elements/typography/typography'
import { Checkbox } from '@src/elements/input/checkbox'

import './permissions.sass'

type Permission = {
  key: string,
  isSelected: boolean,
  isDisabled?: boolean
}
type PermissionGroup = Permission[]

@Component({
  directives: {
    ClickOutside
  }
})
export class MemberPermissionsSettings extends Vue {

  @Prop({ required: true })
  private permissions: MemberPermissions

  @Prop({ required: true })
  private closeCallback: (permissions?: MemberPermissions) => void

  private permissionGroups: PermissionGroup[] = []
  private isUpdated: boolean = false

  constructor () {
    super()
  }

  close () {
    if (this.isUpdated) {
      // submit the changes to the parent component
      this.closeCallback(this.permissions)
    } else {
      this.closeCallback()
    }
  }

  buildPermissions () {
    {/*Hide home workouts*/
    }
    // const homeWorkoutPermissions = [
    //   { key: 'changeActiveHomeWorkout', isSelected: this.permissions.changeActiveHomeWorkout },
    //   {
    //     key: 'createHomeWorkout',
    //     isSelected: !this.permissions.changeActiveHomeWorkout ? false : this.permissions.createHomeWorkout,
    //     isDisabled: !this.permissions.changeActiveHomeWorkout
    //   }
    //   // TODO uncomment this when things are clear
    //   // { key: 'homeWorkout', isSelected: this.permissions.homeWorkout }
    // ]
    const stationWorkoutPermissions = [
      { key: 'changeIndividualStationWorkout', isSelected: this.permissions.changeIndividualStationWorkout },
      { key: 'changeActiveStationWorkout', isSelected: this.permissions.changeActiveStationWorkout },
      {
        key: 'createStationWorkout',
        isSelected: !this.permissions.changeActiveStationWorkout ? false : this.permissions.createStationWorkout,
        isDisabled: !this.permissions.changeActiveStationWorkout
      }
    ]
    const trainingPlanPermissions = [
      { key: 'changeIndividualTrainingPlan', isSelected: this.permissions.changeIndividualTrainingPlan },
      { key: 'changeActiveTrainingPlan', isSelected: this.permissions.changeActiveTrainingPlan },
      {
        key: 'createTrainingPlan',
        isSelected: !this.permissions.changeActiveTrainingPlan ? false : this.permissions.createTrainingPlan,
        isDisabled: !this.permissions.changeActiveTrainingPlan
      }
    ]
    {/*Hide home workouts*/}
    this.permissionGroups = [/*homeWorkoutPermissions,*/ stationWorkoutPermissions, trainingPlanPermissions]
  }

  changePermission (key: string, groupIndex: number, index: number) {
    this.permissionGroups[groupIndex][index].isSelected = !this.permissionGroups[groupIndex][index].isSelected
    this.permissions[key] = !this.permissions[key]

    if (['changeActiveHomeWorkout', 'changeActiveStationWorkout', 'changeActiveTrainingPlan'].includes(key)) {
      if (!this.permissionGroups[groupIndex][index].isSelected) {
        // do not allow create if assign is disabled
        this.permissionGroups[groupIndex][2].isSelected = false
        this.permissionGroups[groupIndex][2].isDisabled = true
        this.permissions[this.permissionGroups[groupIndex][2].key] = false
      } else {
        // enable create permission
        this.permissionGroups[groupIndex][2].isDisabled = false
        // set selected the Assign individual x if Assign Active is selected x
        this.permissionGroups[groupIndex][0].isSelected = true
        this.permissions[this.permissionGroups[groupIndex][0].key] = true
      }
    }

    this.isUpdated = true
  }

  render (h: CreateElement) {
    const permissionGroups = this.permissionGroups.map((group: PermissionGroup, groupIndex: number) => {
      return <div class='group'>{group.map((permission: Permission, index: number) => {
        return <div
          class={`permission ${permission.isSelected ? 'selected selected-checkbox' : ''} ${permission.isDisabled ? 'disabled' : ''}`}>
          <Subtitle1>{this.$t(`PAGE.MEMBERS.TRAINING.PERMISSION.${permission.key.toUpperCase()}`)}</Subtitle1>
          <Checkbox value={permission.isSelected}
                    change={() => this.changePermission(permission.key, groupIndex, index)}
                    disabled={permission.isDisabled} />
        </div>
      })
      }
      </div>
    })

    return <div class='member-permissions-wrapper'>
      <div class='member-permissions' v-click-outside={this.close}>
        <Subtitle1><b>{this.$t('PAGE.MEMBERS.TRAINING.PERMISSION_ALLOW')}</b></Subtitle1>
        {permissionGroups}
      </div>
    </div>
  }

  beforeMount () {
    this.buildPermissions()
  }
}
